import React, {
    useEffect,
    useRef,
    useState
} from 'react';
import {
    Animated,
    Easing
} from 'react-native';
import EStyleSheet from 'react-native-extended-stylesheet';

import gd from '../../../../assets/images/google-drive.png';
import ic from '../../../../assets/images/icloud.png';
import {
    Icon,
    Img,
    Text,
    TouchableOpacity,
    View
} from '../../../../common';
import {
    Log,
    QAMode
} from '../../../../common/Log';
import { COLORS } from '../../../../styles/colors';
import { SwitchWithLabel } from '../../../Visits/snippets/NewVisitModal/snippets';
import { LastBackupInfo } from './LastBackupInfo';

export const CloudBackupControl = ({
    backupInfo,
    isOpen,
    isGoogleDrive = true,
    enable = false,
    onRefresh,
    backupProcessing = false,
    infoProcessing = false,
    infoLoading = false,
    onBackup = () => {
    },
    onRestore = () => {
    },
    onChange = () => {
    },
    isUseBackup = true,
    isUseRestore = true,
}) => {


    const [ isExpanded, setIsExpanded ] = useState(!!isOpen);


    // Animated value for expansion (0 = collapsed, 1 = expanded)
    const expandAnim = useRef(new Animated.Value(isExpanded ? 1 : 0)).current;
    const [ contentHeight, setContentHeight ] = useState(0);

    useEffect(() => {
        Animated.timing(expandAnim, {
            toValue: isExpanded ? 1 : 0,
            duration: 240,
            easing: Easing.out(Easing.cubic),
            useNativeDriver: false, // animating height so native driver can't be used
        })
            .start();
    }, [ isExpanded, expandAnim ]);

    const styles = localStyles;

    // rotation for chevron
    const rotate = expandAnim.interpolate({
        inputRange: [ 0, 1 ],
        outputRange: [ '90deg', '180deg' ],
    });

    // animated height and opacity for expand area
    const animatedHeight = expandAnim.interpolate({
        inputRange: [ 0, 1 ],
        outputRange: [ 0, contentHeight ],
    });
    const animatedOpacity = expandAnim.interpolate({
        inputRange: [ 0, 1 ],
        outputRange: [ 0, 1 ],
    });

    // render the content once so we can reuse it both for measurement and visible area
    const renderExpandContent = () => (<View style={{
        // flex: 1,
        padding: 0,
        margin: 0,
        borderWidth: 0,
        borderColor: 'red',
    }}>
        <View style={styles.startButtonWrap}>
            <View style={[ styles.buttonWrapper, isUseBackup ? {} : styles.hidden ]}>
                <TouchableOpacity
                    style={[ styles.actionButton ]}
                    activeOpacity={isUseBackup ? 0.7 : 1}
                    onPress={isUseBackup ? onBackup : null}>
                    <Text
                        allowFontScaling={false}
                        style={[ styles.actionText, isUseBackup ? {} : styles.actionTextDisabled ]}>{Object.R('button.backup')}</Text>
                </TouchableOpacity>
            </View>
            <View style={[ styles.buttonWrapper, isUseRestore ? {} : styles.hidden ]}>
                <TouchableOpacity
                    style={[ styles.actionButton, styles.actionButtonSeparator ]}
                    activeOpacity={isUseRestore ? 0.7 : 1}
                    onPress={isUseRestore ? onRestore : null}>
                    <Text style={[ styles.actionText, isUseRestore ? {} : styles.actionTextDisabled ]}>{Object.R('button.restore')}</Text>
                </TouchableOpacity>
            </View>
        </View>
    </View>
    );

    return (
        <View style={styles.wrapper}>
            <QAMode>
                <Log
                    value={{ backupInfo }}
                    text={'Backup info'}
                    display={true}/>
            </QAMode>
            <View style={styles.headerRow}>
                <SwitchWithLabel
                    value={enable}
                    enabled={!infoProcessing && !infoLoading && isUseBackup}
                    onValueChange={onChange}
                    caption={Object.R(isGoogleDrive ? 'buttons.googleBackup' : 'buttons.icloudBackup')}
                    style={{
                        borderWidth: 0,
                        marginTop: 0,
                    }}
                />
            </View>

            <TouchableOpacity
                activeOpacity={1}
                style={styles.infoRow}
                onPress={() => {
                    if (!infoProcessing) {
                        setIsExpanded(!isExpanded);
                    }
                    onRefresh && onRefresh();
                }}
                disabled={infoProcessing}
            >
                <View style={styles.logoWrap}>
                    <Img
                        source={isGoogleDrive ? gd : ic}
                        style={styles.logo}
                        resizeMode="cover"
                        objectFit={'scale-down'}/>
                </View>
                <View style={styles.infoTextWrap}>
                    <LastBackupInfo
                        isGoogleDrive={isGoogleDrive}
                        infoProcessing={infoProcessing}
                        backupProcessing={backupProcessing}
                        lastBackup={backupInfo?.createdTime}
                        size={backupInfo?.size}
                        fileName={backupInfo?.name}
                        enable={true}
                        logo={false}
                        redOnError={false}
                    />
                    {/* <Text style={styles.infoLabel}>{Object.R?.('titles.last_backup') || 'Последняя резервная копия:'}</Text> */}
                    {/* <Text style={styles.infoValue}>{backupInfo?.date ? `${backupInfo.date}, ${backupInfo.size || ''}` : lastBackupTitle}</Text> */}
                </View>
                <Animated.View style={[ styles.chevronWrap, { transform: [ { rotate } ] } ]}>
                    <Icon.Up/>
                </Animated.View>
            </TouchableOpacity>

            {/* Hidden measurement container - measures content height once */}
            <View
                style={styles._measureWrap}
                pointerEvents="none"
                accessible={false}
            >
                <View
                    style={styles._measureInner}
                    onLayout={(e) => {
                        const h = e.nativeEvent.layout.height;
                        if (h && h !== contentHeight) {
                            setContentHeight(h);
                        }
                    }}
                >
                    {renderExpandContent()}
                </View>
            </View>

            {/* Animated visible expand area */}
            <Animated.View style={[ styles.expandArea,
                {
                    height: animatedHeight,
                    opacity: animatedOpacity,
                    overflow: 'hidden',
                } ]}>
                <View
                    style={styles._visibleInner}
                    pointerEvents={isExpanded ? 'auto' : 'none'}
                >
                    {renderExpandContent()}
                </View>
            </Animated.View>
        </View>
    );
};
const borderWidth = 1;

const localStyles = EStyleSheet.create({
    wrapper: {
        backgroundColor: '#FFFFFF',
        borderWidth: 1,
        borderColor: COLORS.BORDER_GRAY,
    },
    headerRow: {
        borderWidth: 0,
        borderColor: 'red',
    },
    title: {
        color: COLORS.STANDARD_GRAY,
        fontSize: 18,
    },
    toggleWrapper: {
        width: 57,
        height: 35,
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth,
        borderColor: 'blue',
    },
    toggleImage: {
        width: 55,
        height: 33,
    },
    infoRow: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 12,
        paddingHorizontal: 12,
        borderTopWidth: 1,
        borderTopColor: COLORS.BORDER_LIGHT_GRAY,
    },
    logoWrap: {
        width: 36,
        height: 36,
        marginRight: 12,
        borderColor: 'blue',
        borderWidth: 0,
    },
    infoTextWrap: {
        flex: 1,
    },
    infoLabel: {
        color: COLORS.STANDARD_GRAY,
        fontSize: 14,
    },
    infoValue: {
        color: COLORS.STANDARD_GRAY,
        fontSize: 14,
        fontWeight: '600',
    },
    chevronWrap: {
        width: 24,
        height: 24,
        justifyContent: 'center',
        alignItems: 'center',
    },
    expandArea: {
        width: '100%',
    },
    actionRow: {
        backgroundColor: '#FFFFFF',
        borderTopWidth: 1,
        borderTopColor: COLORS.BORDER_LIGHT_GRAY,
        //height: 48,
        flexDirection: 'row',
        alignItems: 'center',
    },
    actionRowDisabled: { opacity: 0.6 },
    actionIcon: {
        width: 24,
        height: 24,
        marginRight: 8,
        borderWidth: 1,
        borderColor: '#999',
        borderRadius: 4,
    },
    actionIconActive: {
        width: 24,
        height: 24,
        marginRight: 8,
        borderWidth: 1,
        borderColor: '#5C85DD',
        borderRadius: 4,
        backgroundColor: '#5C85DD',
    },
    actionButton: {
        paddingVertical: 11,
        justifyContent: 'center',
        alignItems: 'center',
    },
    actionButtonSeparator: {
        borderLeftWidth: 1,
        borderLeftColor: COLORS.BORDER_LIGHT_GRAY,
    },
    actionTextDisabled: {
        color: COLORS.STANDARD_GRAY_DISABLED,
    },
    actionText: {
        color: COLORS.STANDARD_GRAY,
        fontSize: 14,
        fontWeight: '600',
        //lineHeight: '100%',
        letterSpacing: 0.58,
        fontFamily: '$sourceSansPropFontFamily',
        // fontFamily: 'SourceSansPro-semibold',
    },
    startButtonWrap: {
        flexDirection: 'row',
        borderTopWidth: 1,
        borderTopColor: COLORS.BORDER_LIGHT_GRAY,
        // borderBottomWidth: 1,
        // borderBottomColor: COLORS.BORDER_GRAY,
    },
    startButtonText: {
        color: '#FFFFFF',
        fontSize: 14,
        fontWeight: '600',
        textAlign: 'center',
    },

    // hidden measurement helpers
    _measureWrap: {
        position: 'absolute',
        left: -9999,
        top: -9999,
        width: '100%',
        height: 'auto',
        opacity: 0,
        borderWidth: 1,
        borderColor: 'green',
    },
    _measureInner: {},
    _visibleInner: {},
    logo: {
        width: 36,
        height: 36,
        borderWidth: 0,
        borderColor: 'yellow',
    },
    buttonWrapper: {
        flex: 1,
        borderWidth: 0,
        borderColor: 'blue',
    },
    hidden: {
        //display: 'none',
    },
});
